import { ArrowLeft, Check } from 'lucide-react'
import { useState } from 'react'
import { cn } from '../lib/utils'
import { ProgressBar } from './ui'

// Stepper generico: uma pergunta por vez. Serve pra triagem e aprofundamento.
// Cada pergunta: { codigo, texto, label?, opcoes: [{ codigo, texto }] }.
export function Quiz({ perguntas, respostas, onAnswer, onComplete }) {
  const [i, setI] = useState(0)
  const total = perguntas.length
  const p = perguntas[i]
  if (!p) return null
  const selected = respostas[p.codigo]

  function choose(codigo) {
    onAnswer(p.codigo, codigo)
    window.setTimeout(() => {
      if (i + 1 >= total) onComplete()
      else setI((v) => v + 1)
    }, 260)
  }

  return (
    <div key={p.codigo} className="w-full animate-fade-slide-in">
      <div className="mb-6">
        <div className="mb-3 flex items-center justify-between text-xs font-medium text-muted-foreground">
          {p.label && (
            <span className="inline-flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-primary" />
              {p.label}
            </span>
          )}
          <span className="tabular-nums">
            {i + 1} de {total}
          </span>
        </div>
        <ProgressBar value={i} max={total} />
      </div>

      <h2 className="mb-6 font-display text-xl font-bold leading-snug tracking-tight md:text-2xl">
        {p.texto}
      </h2>

      <div className="space-y-3">
        {p.opcoes.map((o) => {
          const isSel = selected === o.codigo
          return (
            <button
              key={o.codigo}
              type="button"
              onClick={() => choose(o.codigo)}
              className={cn(
                'glass glass-elevate group flex w-full items-center gap-3 rounded-2xl px-5 py-4 text-left',
                'cursor-pointer',
                isSel && 'ring-2 ring-primary',
              )}
            >
              <span
                className={cn(
                  'flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 transition-colors',
                  isSel ? 'border-primary bg-primary text-primary-foreground' : 'border-border',
                )}
              >
                {isSel && <Check className="h-3.5 w-3.5" />}
              </span>
              <span className="text-sm font-medium text-foreground md:text-base">{o.texto}</span>
            </button>
          )
        })}
      </div>

      {i > 0 && (
        <button
          type="button"
          onClick={() => setI((v) => v - 1)}
          className="mt-6 inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" /> Voltar
        </button>
      )}
    </div>
  )
}
